enum Sort {
  DateCreated = 'DATE_CREATED',
  DateAnswered = 'DATE_ANSWERED',
  MostPopular = 'MOST_POPULAR',
}

export default Sort
